import ICalendario from "../interfaces/ICalendario";
import ICalendarioFeriado from "../interfaces/ICalendarioFeriado";
import api from "./Api";
class CalendarioService {
    async obterTodos(): Promise<ICalendario[]> {
        const { data: result } = await api.get<ICalendario[]>('Calendario');
        return result;
    }

    async obterPorId(calendarioID: number): Promise<ICalendario> {
        const { data: result } = await api.get<ICalendario>(`Calendario/${calendarioID}`);

        return result;
    }

    async criar(calendario: ICalendario): Promise<ICalendario> {
        const { data: result } = await api.post('Calendario', calendario);

        return result;
    }

    async atualizar(calendario: ICalendario): Promise<ICalendario> {
        const { data: result } = await api.put(`Calendario/${calendario.id}`, calendario);

        return result;
    }

    async excluir(calendarioID: number): Promise<void> {
        const { data: result } = await api.delete(`Calendario/${calendarioID}`);

        return result;
    }

    async excluirFeriado(feriadoID: number): Promise<void> {
        const { data: result } = await api.delete(`CalendarioFeriado/${feriadoID}`);

        return result;
    }

    async criarFeriado(feriado: ICalendarioFeriado): Promise<ICalendarioFeriado> {
        const { data: result } = await api.post('CalendarioFeriado', feriado);

        return result;
    }

    async atualizarFeriado(feriado: ICalendarioFeriado): Promise<ICalendarioFeriado> {
        const { data: result } = await api.put(`CalendarioFeriado/${feriado.id}`, feriado);

        return result;
    }

    async importarCalendario(calendario: ICalendario): Promise<ICalendario> {
        const formDataCalendario = new FormData();
        formDataCalendario.append('nomeCalendario', calendario.nomeCalendario);
        formDataCalendario.append('tipo', calendario.tipo);
        formDataCalendario.append('estado', calendario.estado);
        formDataCalendario.append('municipio', calendario.municipio);
        formDataCalendario.append('feriadosFile', calendario.file);

        const { data: result } = await api.post('Calendario/Importar', formDataCalendario);

        return result;
    }
}


export default new CalendarioService();